import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css"; // Import Date Range Picker CSS
import "bootstrap-daterangepicker"; // Import Date Range Picker JS
import moment from "moment";
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Form from "../../../Components/Form/Form";
import CustomToast from "../../../Components/CustomToast/CustomToast";
function CreateUserUi({ formik, id, rrb, decodedToken,toast }) {
  useEffect(() => {
    $(".select2bs4").select2({
      theme: "bootstrap4",
    });
    $(".select2bs4").on("change", (e) => {
      const { name, value } = e.target;

      formik.setFieldValue(name, value);
    });

    return () => {
      $(".select2bs4").select2("destroy");
    };
  }, [formik]);
  
  return (
    <div className="content-wrapper" style={{ minHeight: "100vh" }}>
      {/* Content Header */}
      <ContentHeader
        title={id ? "Update Auditor" : "Create Auditor"}
        buttonName={""}
        buttonBoolean={false}
        pageName={id ? "Update Auditor" : "Create Auditor"}
        backButton={true}
      />
      <Form formik={formik} toast={toast}>
      {( decodedToken?.role == 3 || decodedToken?.role == 4) && (
          <div className="form-group" key={"rrb_id"}>
            <label htmlFor={"rrb_id"}>Select RRB</label>
            <div
              className={`${
                formik.errors["rrb_id"] && formik.touched["rrb_id"]
                  ? "border-color-red"
                  : ""
              }`}
            >
              <select
                id="rrb_id"
                name="rrb_id"
                className="form-control w-100 p-2 select_css select2bs4"
                {...formik.getFieldProps("rrb_id")}
              >
                <option value="">Select RRB</option>
                {rrb?.map((val) => {
                  const id = val?.id;
                  return <option value={id}>{val.name}</option>;
                })}
              </select>
            </div>
            {formik.errors["rrb_id"] && formik.touched["rrb_id"] && (
              <div className="select-error">{formik.errors["rrb_id"]}</div>
            )}
          </div>
        )}
        <div className="form-group">
          <label htmlFor="firstname">First Name</label>
          <input
            type="text"
            name="firstname"
            className={`form-control ${
              formik.errors.firstname && formik.touched.firstname
                ? "is-invalid"
                : ""
            }`}
            id="firstname"
            placeholder="Enter First Name"
            {...formik.getFieldProps("firstname")}
          />
          {formik.errors.firstname && formik.touched.firstname && (
            <span className="invalid-feedback">{formik.errors.firstname}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="lastname">Last Name</label>
          <input
            type="text"
            name="lastname"
            className={`form-control ${
              formik.errors.lastname && formik.touched.lastname
                ? "is-invalid"
                : ""
            }`}
            id="lastname"
            placeholder="Enter Last Name"
            {...formik.getFieldProps("lastname")}
          />
          {formik.errors.lastname && formik.touched.lastname && (
            <span className="invalid-feedback">{formik.errors.lastname}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="designation">Designation</label>
          <input
            type="text"
            name="designation"
            className={`form-control ${
              formik.errors.designation && formik.touched.designation
                ? "is-invalid"
                : ""
            }`}
            id="designation"
            placeholder="Enter Designation"
            {...formik.getFieldProps("designation")}
          />
          {formik.errors.designation && formik.touched.designation && (
            <span className="invalid-feedback">
              {formik.errors.designation}
            </span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="phone_number">Phone Number</label>
          <input
            type="tel"
            name="phone_number"
            className={`form-control ${
              formik.errors.phone_number && formik.touched.phone_number
                ? "is-invalid"
                : ""
            }`}
            id="phone_number"
            placeholder="Enter Phone Number"
            {...formik.getFieldProps("phone_number")}
            onInput={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              e.target.value = value.slice(0, 10); // Limit to 10 digits
            }}
          />

          {formik.errors.phone_number && formik.touched.phone_number && (
            <span className="invalid-feedback">
              {formik.errors.phone_number}
            </span>
          )}
        </div>
      </Form>
    </div>
  );
}

export default CreateUserUi;
